import { render } from "./CreateTeam.vue?vue&type=template&id=25a09598&ts=true"
import script from "./CreateTeam.vue?vue&type=script&lang=ts"
export * from "./CreateTeam.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/TTYT_NHS/ZaloOA/ZaloOA_TTYT_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__